// @utility/app/validateInput.js

function validateInput(event, type) {
    try {
        const key = event.key || "";

        // ✅ กฏสำหรับ "ตัวเดียว" (ตอนพิมพ์ทีละตัว)
        const charRules = {
            number: /^[0-9]$/,               // ตัวเลข 0-9
            numberDecimal: /^[0-9.]$/,       // ตัวเลข + จุดทศนิยม
            textNumber: /^[A-Za-z0-9]$/,     // ตัวอักษรอังกฤษ + ตัวเลข
            textSearch: /^[A-Za-z0-9 ]$/,    // อังกฤษ + เลข + เว้นวรรค
            datetime: /^[0-9/: ]$/,          // 0-9 / : + เว้นวรรค
            default: /^[A-Za-z0-9ก-๙ ]$/     // ไทย + อังกฤษ + เลข + เว้นวรรค
        };

        // ✅ กฏสำหรับ "ทั้งสตริง" (ตอน paste)
        const stringRules = {
            number: /^[0-9]+$/,               // 123456
            numberDecimal: /^[0-9.]+$/,       // 12.34
            textNumber: /^[A-Za-z0-9]+$/,     // abc123
            textSearch: /^[A-Za-z0-9 ]+$/,    // abc 123
            datetime: /^[0-9/: ]+$/,          // 12/10/2025 10:30
            default: /^[A-Za-z0-9ก-๙ ]+$/     // ข้อความไทย/อังกฤษ + เลข
        };

        const charRegex = charRules[type] || charRules.default;
        const stringRegex = stringRules[type] || stringRules.default;

        // ✅ ปุ่มควบคุมที่ให้ผ่านตลอด
        const controlKeys = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Tab",
            "Enter",
            "Home",
            "End"
        ];

        if (controlKeys.includes(key)) {
            return true;
        }

        // 🧷 กรณี paste (มือถือ/คอม)
        if (event.type === "paste") {
            try {
                const pasteData =
                    (event.clipboardData || window.clipboardData).getData("text");

                // ถ้าไม่ตรง pattern → บล็อก
                if (!stringRegex.test(pasteData)) {
                    event.preventDefault();
                }
            } catch (err) {
                // กัน error แปลก ๆ จาก clipboard
                event.preventDefault();
            }
            return;
        }

        // key พิเศษที่ยาวกว่า 1 ตัว (เช่น Shift, Meta) → ให้ผ่าน
        if (key.length !== 1) {
            return true;
        }

        // ตรวจตัวเดียว (ตอนพิมพ์)
        if (!charRegex.test(key)) {
            event.preventDefault();
            return false;
        }

        return true;
    } catch (err) {
        // 🛡 Fail-safe: ห้ามให้ error หลุดออกมาเด็ดขาด
        try {
            event.preventDefault();
        } catch (_) {
            // เผื่อบาง environment ไม่มี preventDefault
        }

        // log แบบเบา ๆ เผื่อ debug (ถ้าไม่อยาก log ก็ลบได้)
        console.warn("validateInput blocked unsafe input:", err);
        return false;
    }
}

export default validateInput;
